import React, { useState, useEffect } from 'react'

import treasure from '@/assets/treasure.png';
import podium from '@/assets/podium.png';
import full_game from '@/assets/full_game.png';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ModalAlert } from '@/components/modal/modal.component';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import StartingPointModal from './starting-point-modal.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const CreateEditMechanics = ({ 
    edit, 
    formData, 
    saveData, 
    verifyAndMoveOn, 
    cancel, 
    validJoinCode 
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const membership = useSelector(state => state.userData.membership);
    const [ req ] = useState(['type']);
    const [ showUpgradeModal, setShowUpgradeModal ] = useState(null);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ showStartingPoint, setShowStartingPoint ] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!formData.gameName) {
            navigate('/home/creategame');
        }
    }, [formData])

    function chooseType(e) {
        if (e === 'full' && membership.membership === 0) {
            setShowUpgradeModal('Sorry! You must upgrade your account to be able to take advantage of the full range of game elements in the platform!');
            return;
        }       
        saveData('type', e);
        if (e === 'points') {
            saveData(
                'access', 
                [
                    'points', 
                    'leaderboards', 
                    'levels', 
                    'badges', 
                    'challenges', 
                    'secretCodes', 
                    'teams'
                ]
            );
            saveData('sortLeaders', 'points');
        } else if (e === 'currency') {
            saveData(
                'access', 
                [
                    'currency', 
                    'marketplace', 
                    'items', 
                    'challenges', 
                    'secretCodes', 
                    'teams', 
                    'badges'
                ]
            )
            saveData('sortLeaders', 'currency');
        } else if (e === 'full') {
            saveData(
                'access', 
                [
                    'points', 
                    'leaderboards', 
                    'levels', 
                    'badges', 
                    'challenges', 
                    'secretCodes', 
                    'currency', 
                    'marketplace', 
                    'items'
                ]
            )
            saveData('sortLeaders', 'points');
        }
    }

    function continueCreate() {
        if (!formData.type) {
            setAlertMessage('Please choose a game type before continuing.');
            return;
        }
        verifyAndMoveOn(req, 'name');
    }

    return (
        <div className={`new-game-form ${screenSize}`}>
            <h3>Choose What Game Mechanics You Want to Use</h3>
            <div className="g-space-1"></div>
            <div className={`g-list-item game-type-card ${formData.type === 'currency' ? 'active': ''}`} >
                <div className='image-grid'>
                    <img src={treasure} />
                </div>
                <div className='explanation-grid'>
                    <h3>Currency, Items, and a Store</h3>
                    <p>Players earn currency by finding secret codes and completing challenges. They can then spend that currency on items in the store and try to complete collections!</p>
                    <div className='buttons'>
                        <button 
                            className={`g-button ${screenSize !== 'desktop' ? 'med-btn' : ''}`}
                            onClick={() => chooseType('currency')}>
                            Select
                        </button>
                    </div>
                </div>
            </div>
            <div className="g-space-20"></div>
            <div className={`g-list-item game-type-card ${formData.type === 'points' ? 'active': ''}`} >
                <div className='image-grid'>
                    <img src={podium} />
                    
                </div>
                <div className='explanation-grid'>
                    <h3>Points and Leaderboards</h3>
                    <p>Players earn Experience Points by finding secret codes and completing challenges. Their progress is tracked on a leaderboard and they can earn badges and level up!</p>
                    {
                        (screenSize === 'mobile') &&
                        <div className='g-space-1'></div>
                    }
                    <div className='buttons'>
                        <button 
                            className={`g-button ${screenSize !== 'desktop' ? 'med-btn' : ''}`}
                            onClick={() => chooseType('points')}>
                            Select
                        </button>
                    </div>
                </div>
            </div>
            <div className="g-space-20"></div>
            <div 
                className={`g-list-item game-type-card ${
                    formData.type === 'full' ? 
                    'active' : 
                    ''
                }`} 
            >
                <div className='image-grid'>
                    <img src={full_game} />
                    
                </div>
                <div className={`explanation-grid`}>
                    <div className='explanation-head'>
                        <h3>Full Featured Game!</h3>
                        {
                            (membership && membership.membership === 0) &&
                            <span className='meta'>
                                <button 
                                    className='g-button text-only' 
                                    onClick={() => setShowUpgradeModal(true)}>    
                                    Paid Plans Only
                                    <FontAwesomeIcon icon={faInfoCircle} />
                                </button>
                            </span>
                        }
                    </div>
                    <p>Use any combination of the above games along with premium features like Quests, Prize Packs, and more!</p>
                    {
                        (screenSize === 'mobile') &&
                        <div className='g-space-1'></div>
                    }
                    <div 
                        className='buttons'
                        onClick={() => membership && membership.membership === 0 ? setShowUpgradeModal(true) : null}>
                        <button 
                            className={`g-button ${screenSize !== 'desktop' ? 'med-btn' : ''} ${membership && membership.membership === 0 ? 'disabled' : ''}`}
                            onClick={() => chooseType('full')}>
                            Select
                        </button>
                    </div>
                </div>
            </div>
            <div className="g-space-2"></div>
            {/* <hr /> */}
            <div className='buttons'>
                <button 
                    className={`g-button ${
                        screenSize === 'mobile' 
                        ? 'med-btn' 
                        : ''}`} 
                    onClick={() => cancel()}>
                    Cancel
                </button>
                <button 
                    className={`g-button primary ${
                        screenSize === 'mobile' 
                        ? 'med-btn' 
                        : ''}`} 
                    onClick={() => continueCreate()}>
                    Next
                </button>
            </div>
            <UpgradeRequiredModal 
                show={showUpgradeModal} 
                cancel={() => setShowUpgradeModal(false)} 
                closeButton={true} 
                message={'You must have a paid membership in order to create a full game with access to more than the basic game elements.'} 
                newTab={true} />
            <StartingPointModal
                show={showStartingPoint}
                cancel={() => setShowStartingPoint(false)}
                verifyAndMoveOn={verifyAndMoveOn} />
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage} />
        </div>
    )
}

export default CreateEditMechanics;